import { buildUniqueIdName } from '~/helpers/seo-helpers';
var Accordion = function Accordion() {
  return import('~/components/molecules/Accordion.vue');
};
var MdmLink = function MdmLink() {
  return import( /* webpackChunkName: "link-desktop" */'~/components/atoms/MdmLink.vue');
};
export default {
  name: 'NavItemFolders',
  components: {
    Accordion: Accordion,
    MdmLink: MdmLink
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      buildUniqueIdName: buildUniqueIdName
    };
  }
};